var collectSeatsSelected = [];
// Esta variable tiene la funcionalidad de determinar si viene un mensaje del panel del cliente
var mensajeDelPanel = false;

function showMap() {
    $.get('/api/show_map').done(function (data) {
        showMapAction();
        selected_zone = null;
    });
}

function showMapAction() {
    $('#map').show();

    $.each(zones, function (index, value) {
        $('#zone' + value).hide();
    });
}

function selectSeat(id, limit) {
    console.log("selectSeat")
    if (mensajeDelPanel) {
        // Vamos directamente a seleccionar la butaca para no enviar un mensaje de vuelta
        selectSeatAction(id, limit);
        return;
    }
    if (window.location.href.includes('client')) {
        $.get('/api/client_select_seat/' + id).done(function (data) {
            selectSeatAction(id, limit);
        });
    }
    else {
        $.get('/api/boxoffice_select_seat/' + id).done(function (data) {
            selectSeatAction(id, limit);
        });
    }
}

function selectSeatAction(id, limit) {
    // Llega el mensaje del panel del cliente cuando limit es undefined.
    if (limit === undefined) {
        mensajeDelPanel = true;
        let element = document.querySelector('[data-id="' + id +'"]');
        element.onclick();
        mensajeDelPanel = false;
        return;
    }
    var result = changeSeatState(id, limit);
    console.log(result)
    var $seatSelected = $('[data-id="' + id + '"]');
    if (result === false) {
        if ($seatSelected.attr('class') === 'covid')
            alert('Esta butaca está bloqueada por el protocolo de seguridad contra el COVID-19');
        else if ($seatSelected.attr('class') === 'enajenada')
            alert('Butaca bloqueada');
        else
            alert('Esta butaca ya está ocupada');
    } else {
        calculatePrice();
    }
}

function getSeatInMap(id) {
    var map = collectZones[selected_zone];
    let key = map.findIndex(x => x.seat_id === id);
    return map[key];
}

// Funcion creada para comprobar si el asiento es seleccionable con la regla de "autorrelleno" creada
function canBeSelected(id) {
    var seatInMap = getSeatInMap(id)
    // PMR siempre true
    if (seatInMap.status === 2) {
        return true;
    }
    if (collectSeatsSelected.length) {
        //En esta condicional nos encargamos de que las siguientes seleccionadas sean continuas (no entran PMR)
        var hasSeats = collectSeatsSelected.filter(seat => {
            return seat.x_axis === seatInMap.x_axis
        });
        hasSeats = hasSeats.filter(seat => {
            return (seat.y_axis === seatInMap.y_axis - 1 || seat.y_axis === seatInMap.y_axis + 1) && seat.zone_id === selected_zone;
        });
        if (seatInMap.zone_id === selected_zone) {
            return !!hasSeats.length;
        } else {
            return false;
        }
    } else if(!adjacent){
        // OJO, tener en cuenta que el eje X y el eje Y están invertidos
        return !!(compareXAxis(seatInMap) && compareYAxis(seatInMap) && blockHighFloor(seatInMap));
    }
    return true
}

function canBeUnselected(id){
    var seatInMap = getSeatInMap(id)
    if (seatInMap.status === 2) {
        return true;
    }
    if (collectSeatsSelected.length > 1) {
        if (compareYAxis(seatInMap)) {
            var otherY = collectSeatsSelected.filter(seat => {
                return seat.seat_id !== seatInMap.seat_id;
            }).filter(seat => {
                return compareXAxis(seat) && compareYAxis(seat);
            })
            if(!otherY.length){
                return false;
            }
        } else{
            // Compara que no tenga butacas seleccionadas alrededor de esta, si las tiene no te dejará deseleccionar
            var hasOthers = collectSeatsSelected.filter(seat => {
                return seat.y_axis === seatInMap.y_axis - 1 || seat.y_axis === seatInMap.y_axis + 1;
            })
            if(hasOthers.length > 1){
                return false
            }
        }

    }
    return true;
}

//función creada para evitar que los bloqueo de las butacas crezcan por los lados
function blockHighFloor(seat_selected){
    var map = collectZones[selected_zone];
    var free_array_seatsX = map.filter(seat => {
        return seat.x_axis === seat_selected.x_axis-1 && seat.status === 0;
    });
    var array_seatsX = map.filter(seat => {
        return seat.x_axis === seat_selected.x_axis-1 && seat.status;
    });

    return free_array_seatsX.length === 0 || (free_array_seatsX.length * 100 / array_seatsX.length) < 50;
}

// Esta función tiene que darnos si es el menor o no en la con indice Y seleccionada
function compareXAxis(seat_selected) {
    var map = collectZones[selected_zone];
    // cogemos todos los indices X disponibles en la columna Y de seat_selected
    var array_seatsY = map.filter(seat => {
        return seat.y_axis === seat_selected.y_axis && seat.status === 0;
    });

    // despues de tener filtrados los indices, lo volvemos a filtrar con la condición de comprobar
    // si hay indices X menores al seleccionado
    var array_seatsX_Y = array_seatsY.filter(seat => {
        return seat.x_axis < seat_selected.x_axis;
    });
    return !array_seatsX_Y.length;
}


function compareYAxis(seat_selected) {
    var map = collectZones[selected_zone];
    // cogemos todos los indices Y disponibles en la fila X de seat_selected
    var array_seatsX = map.filter(seat => {
        return seat.x_axis === seat_selected.x_axis && seat.status === 0;
    });
    // despues de tener filtrados los indices, lo volvemos a filtrar con la condiciónes de comprobar
    // si hay indices Y menores o mayores (dos filtros diferentes) al seleccionado, si en alguno de ellos no hay
    // sillas existentes, significa que esta en un extremo
    var array_seats_plusY = array_seatsX.filter(seat => {
        return seat.y_axis > seat_selected.y_axis;
    })
    var array_seats_minusY = array_seatsX.filter(seat => {
        return seat.y_axis < seat_selected.y_axis;
    });

    return !array_seats_plusY.length || !array_seats_minusY.length;
}

// Función que se encarga de añadir la clase parpadeo cuando seleccionas una butaca no seleccionable
function getAllSelectableSeats() {
    var map = collectZones[selected_zone];
    // cogemos todos los disponibles
    var array_seats = map.filter(seat => {
        return seat.status === 0;
    });
    //reusamos la funcion de puede ser seleccionado para savber los posibles sitios seleccionables
    array_seats = array_seats.filter(seat => {
        return canBeSelected(seat.seat_id) && (collectSeatsSelected.findIndex(x => x.seat_id === seat.seat_id) === -1);
    })

    array_seats.forEach(seat => {
        var $seatSelected = $('[data-id="' + seat.seat_id + '"]');
        $seatSelected.addClass('parpadeo');
    })
}

//Funcion que elimina en el mapa el parpadeo
function deleteParpadeoClass() {
    var map = collectZones[selected_zone];
    map.forEach(seat => {
        var $seatSelected = $('[data-id="' + seat.seat_id + '"]');
        $seatSelected.removeClass('parpadeo');
    });
}

// Investigar cuando es false y por qué cojones es false
function changeSeatState(id, limit) {
    var $seatSelected = $('[data-id="' + id + '"]');
    console.log($seatSelected)
    console.log($seatSelected.attr('class'))
    var multifares = $seatSelected.attr('data-multifares') > 1
    var number_seats = $('div[data-ticket-id]').length;
    console.log("Asientos: " + number_seats)
    console.log("Límite: " + limit);
    console.log($seatSelected.attr('class') === 'free' && number_seats < limit);
    if ($seatSelected.attr('class') === 'free' && number_seats < limit ||
        $seatSelected.attr('class') === 'free pmr' && number_seats < limit ||
        $seatSelected.attr('class') === 'free info' && number_seats < limit ||
        $seatSelected.attr('class') === 'free parpadeo' && number_seats < limit
    ) {
        console.log("Primer if");
        if (canBeSelected(id) || (!restriction && !adjacent) ) {
            if ($seatSelected.attr('data-pmr') == 1) {
                $('#myModalPms').data('seat-id', $seatSelected.attr('data-id')).modal('show');
            }

            if ($seatSelected.attr('data-has-info') == 1) { 
                // Establecemos mensaje
                $('#myModalHasInfo .modal-body p').html($seatSelected.attr('data-info'));

                // Abrimos el modal
                $('#myModalHasInfo').data('seat-id', $seatSelected.attr('data-id')).modal('show');
            }

            if ($seatSelected.attr('data-cluster') > 0) {
                var cluster_id = $seatSelected.attr('data-cluster');
                selectCluster(cluster_id, id);
            }

            if (multifares) {                
                // Con este dato sabremos si estamos en la taquilla o no
                var $is_boxoffice = $('[id="is_boxoffice"]');
                
                // Realizamos la petición para obtener las tarifas
                if ($is_boxoffice || ($seatSelected.attr('data-pmr') != 1 && $seatSelected.attr('data-has-info') != 1)) 
                    openMultifareModal(id)

            } else {
    
                $seatSelected.addClass('has-tickets');
    
                var ticket = addTicketToList(id);
                ticket.attr('onclick', 'selectSeat(' + id + ')');
                addInCollectSeatsSelected(id)
                deleteParpadeoClass()
            }
        } else {
            getAllSelectableSeats();
            $('#ModalSeatnoselect').modal('show');
        }
    } else if (
        $seatSelected.attr('class') === 'free has-tickets' ||
        $seatSelected.attr('class') === 'free info has-tickets' ||
        $seatSelected.attr('class') === 'free has-tickets parpadeo' ||
        $seatSelected.attr('class') === 'free pmr has-tickets') {
        if (canBeUnselected(id) || (!restriction && !adjacent) ) {
            $seatSelected.removeClass('has-tickets');
            deleteInCollectSeatsSelected(id);
            removeTicketFromList(id);
            deleteParpadeoClass();
            if ($seatSelected.attr('data-cluster') > 0) {
                var cluster_id = $seatSelected.attr('data-cluster');
                deselectCluster(cluster_id);
            }
        } else{
            $('#ModalSeatdeselect').modal('show');
        }
    } else if ($('div[data-ticket-id]').length >= limit) {
        alert('Máximo número de entradas permitidas');
    } else {
        return false;
    }
}

function openMultifareModal(id) {
    $.get('/api/get_fares_by_seat/' + id).done(function (data) {
        console.log(data);
        
        $('#myModalFares .modal-body').html(data.html);
    });

    $('#myModalFares').modal('show');
}

function fareSelected(seat_id, fare_id)
{
    var $seatSelected = $('[data-id="' + seat_id + '"]');
    $seatSelected.addClass('has-tickets');
    var ticket = addTicketToList(seat_id, fare_id);
    ticket.attr('onclick', 'selectSeat(' + seat_id + ')');
    addInCollectSeatsSelected(seat_id)
    deleteParpadeoClass()
    $('#myModalFares').modal('hide')

    calculatePrice();
}

function selectCluster(cluster_id, id)
{
    var map = collectZones[selected_zone];
    var array_seats = map.filter(seat => {
        return seat.cluster_id === parseInt(cluster_id) && seat.seat_id != id;
    });
    array_seats.forEach(seat => {
        var $seatSelected = $('[data-id="' + seat.seat_id + '"]');
        $seatSelected.addClass('has-tickets');
        var ticket = addTicketToList(seat.seat_id);
        ticket.attr('onclick', 'selectSeat(' + seat.seat_id + ')');
        addInCollectSeatsSelected(seat.seat_id);
    });
}

function deselectCluster(cluster_id) {
    $('.has-tickets').each(function () {
        if($(this).attr('data-cluster')==cluster_id){
            $(this).removeClass('has-tickets');
            removeTicketFromList($(this).data('id'));
        }
    });

    calculatePrice();
}

function addInCollectSeatsSelected(seat_id) {
    var seatInMap = getSeatInMap(seat_id);
    if (seatInMap.status !== 2) {
        collectSeatsSelected.push(seatInMap);
    }
}

function deleteInCollectSeatsSelected(seat_id) {
    var seatInMap = getSeatInMap(seat_id);
    let key = collectSeatsSelected.findIndex(x => x.seat_id === seat_id);
    if (seatInMap.status !== 2) {
        collectSeatsSelected.splice(key, 1);
    }
}

function removeTicket(ticketId) {
    $('[data-ticket-number=' + ticketId + ']').remove();
    // $('#addr'+ticketId).remove();
}

function removeTicketFromList(ticketId) {
    $('[data-ticket-id=' + ticketId + ']').remove();
    $('#addr' + ticketId).remove();
}

function addTicket(id, max, limit) {
    if ($('div[data-ticket-id=' + id + ']').length == max || $('div[data-ticket-id=' + id + ']').length == limit) {
        alert('Máximo número de entradas permitidas');
        return false;
    }

    var ticket = addTicketToList(id);
    ticket.attr('onclick', 'removeTicket(' + ticket.data('ticket-number') + ')');

    calculatePrice();
}

function deselectSeats() {
    $.get('/api/deselect_seats').done(function (data) {
        $('.has-tickets').each(function () {
            $(this).removeClass('has-tickets');
            removeTicketFromList($(this).data('id'));
        });

        calculatePrice();
    });
}

function deselectPmr() {
    $('.has-tickets').each(function () {
        if ($(this).data('pmr') == 1) {
            $(this).removeClass('has-tickets');

            removeTicketFromList($(this).data('id'));
        }

    });

    $('#myModalFares').modal('hide');

    calculatePrice();
}

function deselectHasInfo() {
    
    $('.has-tickets').each(function () {
        
        if ($(this).data('has-info') == 1) {
            $(this).removeClass('has-tickets');

            removeTicketFromList($(this).data('id'));
        }

    });

    $('#myModalFares').modal('hide');

    calculatePrice();
}

function changeOk() {
    if ($('#ok').is(':checked'))
        $('#ok_pmr_btn').prop('disabled', false);
    else
        $('#ok_pmr_btn').prop('disabled', true);
}

function pmrModalAccepted() {
    var seatId = $('#myModalPms').data('seat-id');
    console.log("Asiento seleccionado:", seatId);

    var $seatSelected = $('[data-id="' + seatId + '"]');
    if ($seatSelected.attr('data-multifares') > 1) {
        openMultifareModal(seatId)
    }
    
}

function infoModalAccepted() {
    var seatId = $('#myModalHasInfo').data('seat-id');
    console.log("Asiento seleccionado:", seatId);

    var $seatSelected = $('[data-id="' + seatId + '"]');
    if ($seatSelected.attr('data-multifares') > 1) {
        openMultifareModal(seatId)
    }
    
}
